(function () {
    String.prototype.replaceAll = function (str1, str2, ignore) {
        return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore
            ? "gi"
            : "g")), (typeof (str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);
    };

    String.prototype.endsWith = function (suffix) {
        if (!suffix || !_.isString(suffix)) {
            return false;
        }
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };

    String.isNullOrWhiteSpace = function (string) {
        if (!string || !_.isString(string) || string.trim() === '') {
            return true;
        }
        return false;
    };

    String.prototype.toUtf16Bytes = function () {
        var bytes = [];
        for (var ii = 0; ii < this.length; ii++) {
            var code = this.charCodeAt(ii); // x00-xFFFF
            bytes.push(code & 255, code >> 8); // low, high
        }
        return bytes;
    }
})();
